const TOOLTIP_SELECTOR = "[data-topco-tooltip]";
const TRIGGER_SELECTOR = "[data-topco-tooltip-trigger]";
const CONTENT_SELECTOR = "[data-topco-tooltip-content]";

let areTooltipEventsBound = false;

const closeTooltip = (tooltip) => {
  const trigger = tooltip.querySelector(TRIGGER_SELECTOR);
  tooltip.classList.remove("is-visible");

  if (trigger) {
    trigger.setAttribute("aria-expanded", "false");
  }
};

const openTooltip = (tooltip) => {
  const trigger = tooltip.querySelector(TRIGGER_SELECTOR);
  tooltip.classList.add("is-visible");

  if (trigger) {
    trigger.setAttribute("aria-expanded", "true");
  }
};

const closeAllTooltips = (exceptTooltip = null) => {
  document.querySelectorAll(`${TOOLTIP_SELECTOR}.is-visible`).forEach((tooltip) => {
    if (tooltip !== exceptTooltip) {
      closeTooltip(tooltip);
    }
  });
};

const assignTooltipIds = () => {
  document.querySelectorAll(TOOLTIP_SELECTOR).forEach((tooltip, index) => {
    const trigger = tooltip.querySelector(TRIGGER_SELECTOR);
    const content = tooltip.querySelector(CONTENT_SELECTOR);

    if (!trigger || !content) {
      return;
    }

    if (!content.id) {
      content.id = `topco-tooltip-${index + 1}`;
    }

    trigger.setAttribute("aria-controls", content.id);
  });
};

const handleTooltipClick = (event) => {
  const trigger = event.target.closest(TRIGGER_SELECTOR);
  if (trigger) {
    const tooltip = trigger.closest(TOOLTIP_SELECTOR);
    if (!tooltip) {
      return;
    }

    event.preventDefault();

    if (tooltip.classList.contains("is-visible")) {
      closeTooltip(tooltip);
      return;
    }

    closeAllTooltips(tooltip);
    openTooltip(tooltip);
    return;
  }

  if (!event.target.closest(TOOLTIP_SELECTOR)) {
    closeAllTooltips();
  }
};

const handleTooltipKeydown = (event) => {
  if (event.key === "Escape") {
    closeAllTooltips();
  }
};

const bindTooltipEvents = () => {
  if (areTooltipEventsBound) {
    return;
  }

  document.addEventListener("click", handleTooltipClick);
  document.addEventListener("keydown", handleTooltipKeydown);
  areTooltipEventsBound = true;
};

const bindGravityFormsRerenderEvents = () => {
  document.addEventListener("gform/postRender", assignTooltipIds);

  if (window.jQuery && window.jQuery.fn && window.jQuery(document).on) {
    window.jQuery(document).on("gform_post_render", assignTooltipIds);
  }
};

const initTooltips = () => {
  assignTooltipIds();
  bindTooltipEvents();
};
const isTestEnv =
  typeof globalThis !== "undefined" &&
  typeof globalThis.process !== "undefined" &&
  globalThis.process.env &&
  globalThis.process.env.NODE_ENV === "test";

if (!isTestEnv) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTooltips);
  } else {
    initTooltips();
  }

  bindGravityFormsRerenderEvents();
}

export { initTooltips };
